import React from 'react';
import Top_Banner_All from '../assests/Top_Banner_All.jpg';
import AboutUs from '../assests/About1.jpg';
import About2 from '../assests/About2.jpg';
import About3 from '../assests/About3.jpg';

const About = () => {

  const pageHandler =()=>{
    window.location.href = "/contact";
  }
  return (
    <>
      <section className='pricing-section'>
        <div className="header-image-container">
          <header className={`pricing-header`}>
          <img src={Top_Banner_All} alt="Pricing Background" className="pricing-img" />
          <h1 className="pricing-title">About Us</h1>
          </header>
        </div>
      </section>
      <section className="custom-section">
  <div className="container">
    {/* <!-- First Div --> */}
    <div className="content-div">
      <div className="image-container">
        <img src={AboutUs} alt="Deadlift Image" className="image" />
      </div>
      <div class="text-container">
        <h1 className="intro-text">About Us</h1>
        <h2 className="title">We Will Give You Strength and Health</h2>
        <p className="description">At Vortex Gym, we are passionately committed to helping you achieve the body of your dreams. Whether you're aiming to lose weight, build muscle, or enhance overall wellness, our team is here to support you every step of the way. Our expert trainers and nutritionists will collaborate closely with you to create a personalized fitness and nutrition plan tailored to your unique needs and aspirations. We believe in the power of a holistic approach, ensuring that your journey is not only effective but also sustainable. With Vortex Gym, you're not just reaching your goals—you're transforming your lifestyle and unlocking your full potential.</p>
        <button className="action-button" onClick={pageHandler}>Contact Us</button>
      </div>
    </div>
    {/* <!-- Second Div --> */}
    <div className="grid-div">
      <div className="grid-container">
        <div className="grid-item">
          <img width="100" height="100" src="https://img.icons8.com/ios/100/000000/goal--v1.png" alt="goal--v1"/>
          <h2>Our History</h2>
          <p>Founded in 1985, Vortex Gym began as a small, community-focused fitness center in downtown Los Angeles, aiming to provide accessible exercise options to the local population. Initially offering basic weight training and aerobics classes, the gym quickly gained popularity, leading to expansions throughout the 1990s. By embracing new trends like spinning, yoga, and high-intensity interval training, Vortex Gym attracted a diverse clientele. In the early 2000s, the gym underwent a major renovation, incorporating state-of-the-art equipment and wellness services. Today, Vortex Gym stands as a cornerstone of the community, known for its innovative approach to fitness and inclusive environment.</p>
        </div>
        <div className="grid-item">
          <img src={About2} alt="Man on treadmill" />
        </div>
        <div className="grid-item">
        <img width="612" height="408" src={About3} alt="Many People Together" />
        </div>
        <div className="grid-item">
        <img width="100" height="100" src="https://img.icons8.com/ios-filled/100/mission-of-a-company.png" alt="mission-of-a-company"/>
          <h2>Our Goal</h2>
          <p>Established in 1985, Vortex Gym set a clear goal from the beginning: to empower individuals through fitness and create a welcoming community for all. The gym's founders envisioned a space where people of all fitness levels could achieve their health and wellness goals. Over the years, Vortex Gym has consistently evolved, integrating the latest in exercise science and technology to help members reach their personal best. Through expert guidance, diverse classes, and a supportive environment, Vortex Gym remains dedicated to its mission of fostering a healthier, stronger community, one member at a time.</p>
        </div>
      </div>
    </div>
  </div>
</section>
    </>
  )
}

export default About;
